import { types } from '../types/types'
import { initialCreateBudgetNew } from '../../helpers/pptos'

const initialData = initialCreateBudgetNew()

const initialState = {
    detail: initialData,
    list: [],
    totales: {},
    ppto_filters: {
        time: null,
        fecha_desde: null,
        fecha_hasta: null
    },
    dashboard_filters: {
        time: null,
        fecha_desde: null,
        fecha_hasta: null
    }
}

export const pptoReducer = (state = initialState, action) => {

    switch (action.type) {
        case types.pptoCargarLista:
            return {
                ...state,
                list: [...action.payload]
            }

        case types.budgetsLoadTotalesLista:
            return {
                ...state,
                totales: action.payload
            }

        case types.pptoSetInfo:
            return {
                ...state,
            }

        case types.budgetsLoadDetail:
            return {
                ...state,
                detail: action.payload
            }

        case types.budgetsAddItem:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    items: [...state.detail.items, action.payload]
                }
            }

        case types.budgetsLoadItems:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    items: action.payload
                }
            }

        case types.budgetsUpdateTotales:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    total_cliente: action.payload.total_cliente,
                    total_gasto_p: action.payload.total_gasto_p,
                    margen_gasto_p: action.payload.margen_gasto_p,
                    total_utilidad_p: action.payload.total_utilidad_p,
                    margen_utilidad_p: action.payload.margen_utilidad_p,
                    total_utilidad_r: action.payload.total_utilidad_r,
                    margen_utilidad_r: action.payload.margen_utilidad_r,
                    total_costos_directos: action.payload.total_costos_directos
                }
            }

        case types.budgetsSetNewIds:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    id: action.payload.id,
                    numero: action.payload.numero
                }
            }

        case types.budgetsUpdateNewFolio:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    numero: action.payload
                }
            }

        case types.budgetsUpdateDatosInicialesNotSave:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    id_cliente: action.payload.id_cliente,
                    cliente: action.payload.cliente,
                    referencia: action.payload.referencia,
                    id_area_negocio: action.payload.id_area_negocio,
                    area_negocio: action.payload.area_negocio,
                    id_ejecutivo: action.payload.id_ejecutivo,
                    ejecutivo: action.payload.ejecutivo,
                    id_moneda: action.payload.id_moneda,
                    moneda: action.payload.moneda,
                    contacto_id: action.payload.contacto_id,
                    contacto_nombre: action.payload.contacto_nombre,
                    contacto_email: action.payload.contacto_email,
                    fecha_asignacion: action.payload.fecha_asignacion,
                    validacion_id_regla: action.payload.validacion_id_regla,
                    validacion_rentabilidad_optima: action.payload.validacion_rentabilidad_optima,
                    validacion_descripcion_regla: action.payload.validacion_descripcion_regla,
                    valor_tipo_cambio: action.payload.valor_tipo_cambio,
                    id_proyecto: action.payload.id_proyecto,
                    nombre_proyecto: action.payload.nombre_proyecto,
                }
            }

        case types.budgetsUpdateCondicionesNotSave:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    id_forma_pago: action.payload.id_forma_pago,
                    forma_pago: action.payload.forma_pago,
                    fecha_vencimiento: action.payload.fecha_vencimiento,
                    observaciones: action.payload.observaciones,
                    terminos_condiciones: action.payload.terminos_condiciones,
                    otras_formas_pago: action.payload.otras_formas_pago,
                    fecha_estimada_forma_pago: action.payload.fecha_estimada_forma_pago
                }
            }

        case types.budgetsUpdateProjections:

            console.log('projections reducer--', action.payload)

            return {
                ...state,
                detail: {
                    ...state.detail,
                    projections: action.payload
                }
            }

        case types.budgetsUpdateInfoFactNotSave:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    facturacion_nro_oc_cliente: action.payload.facturacion_nro_oc_cliente,
                    facturacion_tipo: action.payload.facturacion_tipo,
                    facturacion_id_cliente: action.payload.facturacion_id_cliente,
                    facturacion_fecha: action.payload.facturacion_fecha,
                    facturacion_url_oc_cliente: action.payload.facturacion_url_oc_cliente
                }
            }

        case types.budgetsUpdateColumnName:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    nombre_columna_dias: action.payload.nombre_columna_dias
                }
            }

        case types.budgetsUpdateMontosFinalNotSave:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    descuento: action.payload.descuento,
                    descuento_porcentaje: action.payload.descuento_porcentaje,
                    total_cliente: action.payload.total_cliente,
                    afecto: action.payload.afecto,
                    total_impuesto: action.payload.total_impuesto,
                    total: action.payload.total,
                    total_utilidad_p: action.payload.total_utilidad_p,
                    margen_gasto_p: action.payload.margen_gasto_p,
                    margen_utilidad_p: action.payload.margen_utilidad_p,
                    id_tipo_documento: action.payload.id_tipo_documento,
                    porcentaje_impuesto: action.payload.porcentaje_impuesto,
                    tipo_calculo: action.payload.tipo_calculo
                }
            }


        case types.budgetsUpdateValidationStatus:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    validacion_estado: action.payload.validacion_estado,
                    validacion_nota: action.payload.validacion_nota,
                    validacion_rentabilidad_optima: action.payload.validacion_rentabilidad_optima,
                    validacion_id_regla: action.payload.validacion_id_regla
                }
            }

        case types.budgetsSetIsTemplate:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    is_template: action.payload,
                }
            }

        case types.budgetsSetFiltersList:
            return {
                ...state,
                ppto_filters: action.payload
            }

        case types.dashboardSetFiltersList:
            return {
                ...state,
                dashboard_filters: action.payload
            }

        default:
            return state;
    }

}
